import isEqual from 'lodash/isEqual';
import get from 'lodash/get';
import * as utils from './Utils';


export function formatCartItem(itemRow) {
  let item = {};
  item['id'] = `${itemRow.id}`;
  item['title'] = itemRow.title;
  item['quantity'] = itemRow.quantity;
  item['price'] = itemRow.price;
  item['product_id'] = `${itemRow.product_id}`;
  item['product_title'] = itemRow.product_title;
  item['variant_id'] = `${itemRow.variant_id}`;
  item['variant_title'] = itemRow.variant_title;
  item['image_url'] = itemRow.image || itemRow.image_url || '';
  return item;
}

export function formatCartResponse(response) {
  let data = {};
  data['currency'] = response.currency;
  data['total_price'] = response.total_price;
  data['total_discount'] = response.total_discount;

  let items = [];
  if (response.items && response.items.length > 0) {
    response.items.forEach((itemRow) => {
      let item = formatCartItem(itemRow);
      items.push(item);
    })
  }
  data['items'] = items;
  return data;
}


function getAddedCartItems(response) {
  const existingData = get(window.OnVoardEventsData, 'shopline_cart', {});
  const existingMapper = {};
  if (existingData.items) {
    existingData.items.forEach((itemRow) => {
      existingMapper[`${itemRow.id}`] = parseInt(itemRow.quantity);
    })
  }

  const currentMapper = {};
  if (response.items) {
    response.items.forEach((itemRow) => {
      currentMapper[`${itemRow.id}`] = parseInt(itemRow.quantity);
    })
  }

  let addedIds = utils.getAddedCartItemIds(existingMapper, currentMapper);
  let addedItems = [];
  if (response.items) {
    response.items.forEach((itemRow) => {
      let itemId = `${itemRow.id}`;
      if (!addedIds.includes(itemId)) return;
      addedItems.push(itemRow)
    })
  }

  return addedItems;
}

export function handleCartUpdate(response) {
  if (window.OnVoardData) {
    window.OnVoardData['cart'] = response;
  }

  let noChange = isEqual(window.OnVoardEventsData['shopline_cart'], response);
  let isNew = !window.OnVoardEventsData['shopline_cart'] ? true : false;

  // no cart change
  if (noChange) return;

  // if first time loading, don't dispatch added cart items
  let addedCartItems = [];
  if (!isNew) addedCartItems = getAddedCartItems(response);

  window.OnVoardEventsData['shopline_cart'] = response;
  utils.dispatchCartUpdateEvent(response);
  addedCartItems.forEach((item) => {
    utils.dispatchAddCartItemEvent(item);
  })
}

export function setupCartUpdateEvent() {
  if (window.OnVoardEventsData.setupCartUpdateEvent) return;
  window.OnVoardEventsData.setupCartUpdateEvent = true;

  let cartUpdatePaths = [];
  utils.interceptRequests(cartUpdatePaths, (response, url) => {
    response = utils.parseResponse(response);
    if (!response) return;
    if (!response.data) return;
    handleCartUpdate(response.data);
  });

  let shoplinetriggerPaths = [
    "/leproxy/api/carts/cart",
  ];

  let triggerCartUpdate = () => {
    utils.getRq({
      "url": "/api/carts/ajax-cart",
      "headers": {
        'Content-Type': 'application/json',
      },
      "successCallback": (response) => {
        response = utils.parseResponse(response);
        if (!response) return;
        handleCartUpdate(response);
      },
      "errorCallback": () => {}
    });
  };

  utils.interceptRequests(shoplinetriggerPaths, (response, url) => {
    triggerCartUpdate();
  });
}


export function loadCart() {
  let successCallback = (response) => {
    response = utils.parseResponse(response);
    if (!response) return;
    handleCartUpdate(response);
  };

  let errorCallback = () => {};

  utils.getRq({
    "url": "/api/carts/ajax-cart",
    "headers": {
      'Content-Type': 'application/json',
    },
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

